export default {"src":"/_next/static/media/step-3.40cdb7b4.svg","height":287,"width":512,"blurWidth":0,"blurHeight":0};